/* Side Eye Supply Co — theme JS */
(function(){
  const money = c => 'R' + Math.round(c/100).toLocaleString('en-ZA');

  /* mobile nav */
  window.toggleNav = function(){ document.querySelector('.navlinks')?.classList.toggle('open'); };

  /* accordion */
  window.accToggle = function(btn){ btn.closest('.item')?.classList.toggle('open'); };

  /* ---------- Cart drawer ---------- */
  const overlay = () => document.getElementById('drawerOverlay');
  const drawer  = () => document.getElementById('cartDrawer');
  window.openCart  = function(){ overlay()?.classList.add('open'); drawer()?.classList.add('open'); document.body.style.overflow='hidden'; refreshCart(); };
  window.closeCart = function(){ overlay()?.classList.remove('open'); drawer()?.classList.remove('open'); document.body.style.overflow=''; };

  async function getCart(){ const r = await fetch('/cart.js'); return r.json(); }

  /* ---------- Cart-aware upsell scoring ----------
     1. Every item in the cart votes for its mapped companions (UPSELL_MAP).
     2. Companions already in the cart, or unavailable, are dropped.
     3. If nothing scored (e.g. a product with no mapped companions), the
        generic fallback pool fills in at score 0 so the drawer still shows something useful.
     4. Ties are broken by how closely the candidate's price closes the
        remaining free-shipping gap — so the suggestion someone actually needs
        to add to unlock free shipping floats to the top, not just "cheapest". */
  function computeUpsells(cart, remaining){
    const CATALOG = window.UPSELL_CATALOG || {};
    const MAP = window.UPSELL_MAP || {};
    const FALLBACK = window.UPSELL_FALLBACK || [];
    const inCart = {};
    cart.items.forEach(function(it){ if(it.handle) inCart[it.handle] = true; });

    const scores = {};
    cart.items.forEach(function(it){
      (MAP[it.handle] || []).forEach(function(h){
        if(inCart[h]) return;
        const p = CATALOG[h];
        if(!p || !p.available) return;
        scores[h] = (scores[h] || 0) + 1;
      });
    });
    FALLBACK.forEach(function(h){
      if(inCart[h]) return;
      const p = CATALOG[h];
      if(!p || !p.available) return;
      if(!(h in scores)) scores[h] = 0;
    });

    const candidates = Object.keys(scores).map(function(h){
      return { handle: h, score: scores[h], product: CATALOG[h] };
    });
    candidates.sort(function(a, b){
      if(b.score !== a.score) return b.score - a.score;
      const da = Math.abs(a.product.price - remaining);
      const db = Math.abs(b.product.price - remaining);
      return da - db;
    });
    return candidates.slice(0, 2);
  }

  /* Size-only products with a few short variants (e.g. Pawvana S/M/L) get one small
     button per size. Products with colours or many options (leash, harness) get a
     "Choose" link to the product page, so we never show a row of cryptic letters
     and never silently add the wrong colour/size. */
  function renderUpsellItem(c){
    const p = c.product;
    const vs = p.variants || [];
    const multi = vs.length > 1;
    const sizeButtons = multi && vs.length <= 4 && vs.every(v => (v.title || '').length <= 3);
    const action = !multi
      ? `<button type="button" class="cu-add" data-vid="${p.variantId}">Add</button>`
      : sizeButtons
        ? `<div class="cu-sizes">${vs.map(v => `<button type="button" class="cu-add cu-sz" data-vid="${v.id}" title="Add ${v.title}" aria-label="Add ${v.title}"${v.available ? '' : ' disabled'}>${v.title}</button>`).join('')}</div>`
        : `<a class="cu-add" href="${p.url}" style="text-decoration:none">Choose</a>`;
    const price = multi && p.priceMin ? 'From ' + money(p.priceMin) : money(p.price);
    return `<div class="cu-item" data-handle="${c.handle}">
        <img src="${p.image || ''}" alt="">
        <div class="cu-info"><div class="cu-t">${p.title}</div><div class="cu-p">${price}</div></div>
        ${action}
      </div>`;
  }

  function renderCart(cart){
    const cnt = document.getElementById('cartCnt'); if(cnt) cnt.textContent = cart.item_count;
    const wrap = document.getElementById('cdItems'); const foot = document.getElementById('cdFoot');
    const shipbar = document.getElementById('cdShipBar');
    if(!wrap) return;
    if(cart.item_count === 0){
      wrap.innerHTML = '<div class="cd-empty"><p>Your bag is empty.</p><p style="margin-top:10px;"><a class="btn btn-dark" href="/collections/all">Shop the gear</a></p></div>';
      if(foot) foot.style.display='none';
      if(shipbar) shipbar.style.display='none';
      return;
    }
    if(foot) foot.style.display='block';
    wrap.innerHTML = cart.items.map(it => `
      <div class="cd-item" data-key="${it.key}">
        <img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/,'_120x$1$2') : ''}" alt="">
        <div style="flex:1">
          <div class="ci-t">${it.product_title}</div>
          <div class="ci-v">${it.variant_title && it.variant_title!=='Default Title' ? it.variant_title : ''}</div>
          <div class="ci-row">
            <div class="cd-qty">
              <button type="button" class="cq" data-act="dec" data-key="${it.key}" data-qty="${it.quantity}">−</button><span>${it.quantity}</span><button type="button" class="cq" data-act="inc" data-key="${it.key}" data-qty="${it.quantity}">+</button>
            </div>
            <div class="ci-price">${money(it.final_line_price)}</div>
          </div>
        </div>
      </div>`).join('');
    const sub = document.getElementById('cdSub'); if(sub) sub.textContent = money(cart.total_price);

    /* free-shipping progress bar */
    const thr = parseInt(document.body.dataset.freeship||'80000',10);
    const remaining = thr - cart.total_price;
    if(shipbar){
      shipbar.style.display='block';
      const fill = document.getElementById('cdShipFill');
      const label = document.getElementById('cdShipLabel');
      const pct = Math.max(0, Math.min(100, Math.round(cart.total_price/thr*100)));
      if(fill){
        fill.style.width = pct+'%';
        fill.classList.toggle('done', remaining<=0);
      }
      if(label){
        label.classList.toggle('done', remaining<=0);
        label.innerHTML = remaining>0
          ? `You're <b>${money(remaining)}</b> away from free SA shipping 🚚`
          : `🎉 Free SA shipping unlocked!`;
      }
    }

    /* cart-aware upsell */
    const ups = document.getElementById('cdUpsell');
    const cuList = document.getElementById('cuList');
    const cuHeading = document.getElementById('cuHeading');
    if(ups && cuList){
      if(remaining<=0){
        ups.style.display='none';
      } else {
        const picks = computeUpsells(cart, remaining);
        if(picks.length===0){
          ups.style.display='none';
        } else {
          const relevant = picks.some(function(p){ return p.score>0; });
          if(cuHeading) cuHeading.textContent = relevant ? '🐾 Goes well with what\'s in your bag' : '🐾 Dog owners also add';
          cuList.innerHTML = picks.map(renderUpsellItem).join('');
          ups.style.display='block';
        }
      }
    }
  }

  async function refreshCart(){ renderCart(await getCart()); }

  async function changeLine(key, qty){
    try{
      const r = await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})});
      const cart = await r.json();
      if(cart && cart.items){ renderCart(cart); } else { refreshCart(); }
    }catch(err){ refreshCart(); }
  }

  window.addVariant = async function(vid){
    try{
      await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:parseInt(vid,10),quantity:1})});
      await refreshCart();
    }catch(e){ refreshCart(); }
  };

  document.addEventListener('click', function(e){
    const b = e.target.closest('.cq');
    if(b){ e.preventDefault(); const key=b.dataset.key; const cur=parseInt(b.dataset.qty,10)||0; const next=b.dataset.act==='inc'?cur+1:Math.max(0,cur-1); changeLine(key,next); return; }
    const a = e.target.closest('.cu-add');
    if(a && a.dataset.vid){ e.preventDefault(); if(a.disabled) return; window.addVariant(a.dataset.vid); return; }
  });

  /* ---------- Add to cart (AJAX) ---------- */
  window.ajaxAdd = async function(form){
    const btn = form.querySelector('[type=submit]'); const label = btn ? btn.textContent : '';
    if(btn){ btn.disabled=true; btn.textContent='Adding…'; }
    try{
      const fd = new FormData(form);
      const r = await fetch('/cart/add.js',{method:'POST',body:fd});
      if(!r.ok){ const err = await r.json(); alert(err.description||'Could not add to bag'); }
      else { await refreshCart(); openCart(); }
    } finally { if(btn){ btn.disabled=false; btn.textContent=label; } }
    return false;
  };

  document.addEventListener('DOMContentLoaded', refreshCart);
})();
